var map = {
	"./ID/en.md": [
		7746,
		7746
	],
	"./ID/id.md": [
		89256,
		9256
	],
	"./MY/en-my.md": [
		84560,
		4560
	],
	"./SG/en-sg.md": [
		49988,
		9988
	],
	"./VN/en.md": [
		93861,
		3861
	],
	"./VN/vi.md": [
		94563,
		4563
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66866;
module.exports = webpackAsyncContext;